import { Button, DialogActions, DialogTitle } from "@mui/material";
import React from "react";
import styled from "styled-components";

import PresentationPermissionsController from "js/controllers/PresentationPermissionsController";
import getLogger, { LogGroup } from "js/core/logger";
import withProgressDialog from "js/core/utilities/withProgressDialog";
import { BeautifulDialog, DialogContent, ShowErrorDialog } from "js/react/components/Dialogs/BaseDialog";

const logger = getLogger(LogGroup.PERMISSIONS);

const StyledDialogTitle = styled(DialogTitle)`
    display: flex;
    width: 100%;
 `;

const StyledDialogActions = styled(DialogActions)`
    display: flex;
    justify-content: space-between;
`;

interface InviteEditCollaboratorDialogProps {
    presentationId: string;
    email: string;
    closeDialog: (result: boolean) => void;
    message: string;
    title: string;
}

function InviteEditCollaboratorDialog({ email, closeDialog, message, title }: InviteEditCollaboratorDialogProps) {
    const handleInviteCollaborator = () => {
        withProgressDialog({
            title: "Inviting collaborator",
            action: async () => {
                try {
                    await PresentationPermissionsController.addPresentationPermissionsForUsers({
                        users: [{ email, permissions: { write: { object: true, permissions: true }, read: { object: true, permissions: true }, owner: false } }],
                        analyticsProps: {
                            location: "assign"
                        }
                    });

                    closeDialog(true);
                } catch (err) {
                    logger.error(err, "[InviteEditCollaboratorDialog] Failed to invite collaborator");

                    ShowErrorDialog({
                        title: "Failed to invite collaborator",
                        message: err.message
                    });
                }
            }
        });
    };

    return (
        <BeautifulDialog closeDialog={() => closeDialog(false)}>
            <StyledDialogTitle disableTypography={true}>
                <h2>{title}</h2>
            </StyledDialogTitle>
            <DialogContent>
                <p>{message}</p>
            </DialogContent>
            <StyledDialogActions >
                <Button onClick={() => closeDialog(false)}>Nevermind</Button>
                <Button onClick={handleInviteCollaborator} color="primary">Invite Collaborator</Button>
            </StyledDialogActions>
        </BeautifulDialog>
    );
}

export default PresentationPermissionsController.withStateInitializer(InviteEditCollaboratorDialog, ({ presentationId }) => presentationId);
